
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/evcharging/consultation",
      function () {
        return require("private-next-pages/evcharging/consultation.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/evcharging/consultation"])
      });
    }
  